'use client';

import React, { useState, useRef, useEffect } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';


const programs = [
  {
    id: 'dpharm',
    tagColor: 'tag-green',
    title: 'D.Pharm',
    subtitle: 'Diploma in Pharmacy',
    duration: '2 Years',
    seats: '60 Seats',
    eligibility:
      '10+2 with Physics, Chemistry, Biology/Mathematics (minimum 45%)',
    accreditation: 'PCI & BTE Approved',

    description:
      'A foundational two-year diploma program designed to prepare students for pharmacy practice. Approved by the Pharmacy Council of India (PCI) and Board of Technical Education (BTE), this program provides comprehensive training in pharmaceutical sciences.',

    image:
      'https://images.unsplash.com/photo-1622865318365-7ea7d2df73b0',

    imageAlt:
      'Pharmacy dispensing laboratory with medicine bottles and equipment, bright clinical white environment',

    curriculum: [
      'Pharmaceutics & Drug Formulation',
      'Pharmaceutical Chemistry',
      'Pharmacognosy',
      'Human Anatomy & Physiology',
      'Biochemistry & Clinical Pathology',
      'Hospital & Clinical Pharmacy',
    ],

    careers: [
      'Registered Pharmacist',
      'Hospital Pharmacist',
      'Medical Store Owner',
      'Drug Inspector (entry-level)',
      'Pharmaceutical Sales',
    ],

    color: 'secondary',
    comingSoon: false,
  },


  {
    id: 'bpharm',
    tagColor: 'tag-blue',
    title: 'B.Pharm',
    subtitle: 'Bachelor of Pharmacy',
    duration: '4 Years',
    seats: '60 Seats',

    eligibility: '',
    accreditation: '',

    description:
      'A comprehensive undergraduate Bachelor of Pharmacy program designed to provide advanced knowledge in pharmaceutical sciences, research, and clinical applications.',

    image:
      'https://img.rocket.new/generatedImages/rocket_gen_img_18406a950-1772702842018.png',

    imageAlt:
      'Modern pharmaceutical research laboratory with microscopes and analytical equipment',

    curriculum: [],

    careers: [],

    color: 'primary',
    comingSoon: true,
  },
];


export default function ProgramsGrid() {

  const [activeTab, setActiveTab] = useState<string>('dpharm');

  const sectionRef = useRef<HTMLElement>(null);


  useEffect(() => {

    const observer = new IntersectionObserver(
      (entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting && sectionRef.current) {

            sectionRef.current.style.opacity = '1';

            sectionRef.current.style.transform =
              'translateY(0)';

            observer.disconnect();

          }

        });

      },
      { threshold: 0.1 }
    );


    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }


    return () => observer.disconnect();

  }, []);


  const active =
    programs.find(
      (program) => program.id === activeTab
    ) || programs[0];
    return (
  <section data-component-id="src/app/programs/components/ProgramsGrid.tsx:129:2" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="129" data-component-end-line="551" data-component-file="ProgramsGrid.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-20%20md%3Apy-28%20px-6%22%7D"
    ref={sectionRef}
    className="py-20 md:py-28 px-6"
    style={{
      opacity: 0,
      transform: 'translateY(40px)',
      transition:
        'opacity 1s cubic-bezier(0.16,1,0.3,1), transform 1s cubic-bezier(0.16,1,0.3,1)',
    }}
  >

    <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:140:4" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="140" data-component-end-line="549" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%22%7D" className="max-w-7xl mx-auto">

      {/* Header */}
      <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:143:6" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="143" data-component-end-line="195" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-10%22%7D" className="mb-10">

        <span data-component-id="src/app/programs/components/ProgramsGrid.tsx:145:8" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="145" data-component-end-line="147" data-component-file="ProgramsGrid.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22section-label%20block%20mb-3%22%2C%22textContent%22%3A%22Our%20Offerings%22%7D" className="section-label block mb-3">
          Our Offerings
        </span>


        <h2 data-component-id="src/app/programs/components/ProgramsGrid.tsx:150:8" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="150" data-component-end-line="155" data-component-file="ProgramsGrid.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-display%20text-foreground%20mb-6%22%2C%22textContent%22%3A%22Choose%20Your%22%7D" className="text-display text-foreground mb-6">
          Choose Your{' '}
          <em data-component-id="src/app/programs/components/ProgramsGrid.tsx:152:10" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="152" data-component-end-line="154" data-component-file="ProgramsGrid.tsx" data-component-name="em" data-component-content="%7B%22elementName%22%3A%22em%22%2C%22className%22%3A%22font-normal%20italic%20text-primary%22%2C%22textContent%22%3A%22Path%22%7D" className="font-normal italic text-primary">
            Path
          </em>
        </h2>


        {/* Tabs */}
        <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:159:8" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="159" data-component-end-line="193" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-2%20flex-wrap%22%7D" className="flex gap-2 flex-wrap">

          {programs.map((prog) => (

            <button data-component-id="src/app/programs/components/ProgramsGrid.tsx:163:12" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="163" data-component-end-line="189" data-component-file="ProgramsGrid.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
              key={prog.id}
              disabled={prog.comingSoon}
              onClick={() =>
                !prog.comingSoon &&
                setActiveTab(prog.id)
              }
              className={`
                px-5 py-2.5 rounded-full text-sm font-semibold
                transition-all duration-300

                ${
                  prog.comingSoon
                    ? 
                    'bg-muted text-muted-foreground/50 border border-border cursor-not-allowed'
                    :
                    activeTab === prog.id
                    ?
                    'bg-primary text-white shadow-primary-glow'
                    :
                    'bg-muted text-muted-foreground hover:text-foreground border border-border'
                }
              `}
            >
              {prog.title}

            </button>

          ))}

        </div>

      </div>



      {/* Program Content */}

      {active.comingSoon ? (

        /* B.Pharm Coming Soon State */

        <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:205:8" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="205" data-component-end-line="273" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20min-h-%5B520px%5D%20rounded-2xl%20overflow-hidden%20border%20border-border%22%7D" className="relative min-h-[520px] rounded-2xl overflow-hidden border border-border">

          {/* Background Image */}
          <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:208:10" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="208" data-component-end-line="217" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%22%7D" className="absolute inset-0">

            <AppImage data-component-id="src/app/programs/components/ProgramsGrid.tsx:210:12" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="210" data-component-end-line="215" data-component-file="ProgramsGrid.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22className%22%3A%22object-cover%20grayscale%20blur-sm%20opacity-40%22%7D"
              src={active.image}
              alt={active.imageAlt}
              fill
              className="object-cover grayscale blur-sm opacity-40"
            />

          </div>


          {/* Glass Layer */}
          <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:221:10" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="221" data-component-end-line="227" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20absolute%20inset-0%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20bg-background%2F65%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20backdrop-blur-md%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%22%7D"
            className="
              absolute inset-0
              bg-background/65
              backdrop-blur-md
            "
          />


          {/* Content */}

          <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:232:10" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="232" data-component-end-line="270" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20relative%20z-10%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20min-h-%5B520px%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20flex%20items-center%20justify-center%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20text-center%20px-6%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%22%7D"
            className="
              relative z-10
              min-h-[520px]
              flex items-center justify-center
              text-center px-6
            "
          >

            <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:241:12" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="241" data-component-end-line="268" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">

              <h3 data-component-id="src/app/programs/components/ProgramsGrid.tsx:243:14" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="243" data-component-end-line="247" data-component-file="ProgramsGrid.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-serif%20text-5xl%20text-foreground%20tracking-tight%22%2C%22textContent%22%3A%22B.Pharm%22%7D" className="font-serif text-5xl text-foreground tracking-tight">

                B.Pharm

              </h3>


              <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:250:14" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="250" data-component-end-line="257" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20w-16%20h-px%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20bg-border%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20mx-auto%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20my-6%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%22%7D"
                className="
                  w-16 h-px
                  bg-border
                  mx-auto
                  my-6
                "
              />


              <p data-component-id="src/app/programs/components/ProgramsGrid.tsx:260:14" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="260" data-component-end-line="265" data-component-file="ProgramsGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted-foreground%20max-w-md%22%2C%22textContent%22%3A%22Bachelor%20of%20Pharmacy%20admissions%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20will%20be%20announced%20soon.%22%7D" className="text-muted-foreground max-w-md">

                Bachelor of Pharmacy admissions
                will be announced soon.

              </p>


            </div>

          </div>


        </div>


      ) : (


        /* D.Pharm Details */

        <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:281:8" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="281" data-component-end-line="545" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-12%20gap-10%20items-start%22%7D"
          key={activeTab}
          className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start"
          style={{
            animation:
              'fadeIn 0.5s ease forwards',
          }}
        >


          {/* Image + Quick Info */}

          <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:293:10" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="293" data-component-end-line="387" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-5%22%7D" className="lg:col-span-5">


            <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:296:12" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="296" data-component-end-line="321" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22img-reveal-wrapper%20revealed%22%7D"
              className="img-reveal-wrapper revealed"
              style={{ height: '360px' }}
            >

              <AppImage data-component-id="src/app/programs/components/ProgramsGrid.tsx:301:14" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="301" data-component-end-line="307" data-component-file="ProgramsGrid.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22className%22%3A%22object-cover%20w-full%20h-full%22%7D"
                src={active.image}
                alt={active.imageAlt}
                fill
                className="object-cover w-full h-full"
                sizes="(max-width:1024px) 100vw, 42vw"
              />


              <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:310:14" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="310" data-component-end-line="318" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20top-4%20left-4%22%7D" className="absolute top-4 left-4">

                <span data-component-id="src/app/programs/components/ProgramsGrid.tsx:312:16" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="312" data-component-end-line="316" data-component-file="ProgramsGrid.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
                  className={`tag-pill ${active.tagColor}`}
                >
                  {active.title}
                </span>

              </div>


            </div>



            {/* Facts */}

            <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:327:12" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="327" data-component-end-line="384" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-6%20grid%20grid-cols-2%20gap-4%22%7D" className="mt-6 grid grid-cols-2 gap-4">

              {[
                {
                  icon: 'ClockIcon',
                  label: 'Duration',
                  value: active.duration,
                },
                {
                  icon: 'UserGroupIcon',
                  label: 'Intake',
                  value: active.seats,
                },
                {
                  icon: 'DocumentCheckIcon',
                  label: 'Accreditation',
                  value: active.accreditation,
                },
                {
                  icon: 'AcademicCapIcon',
                  label: 'Mode',
                  value: 'Full Time',
                },

              ].map((fact) => (

                <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:353:16" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="353" data-component-end-line="379" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22step-card%20flex%20items-start%20gap-3%20p-4%22%7D"
                  key={fact.label}
                  className="step-card flex items-start gap-3 p-4"
                >

                  <Icon data-component-id="src/app/programs/components/ProgramsGrid.tsx:358:18" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="358" data-component-end-line="362" data-component-file="ProgramsGrid.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-primary%20mt-0.5%20shrink-0%22%7D"
                    name={fact.icon as any}
                    size={18}
                    className="text-primary mt-0.5 shrink-0"
                  />


                  <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:365:18" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="365" data-component-end-line="376" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">

                    <p data-component-id="src/app/programs/components/ProgramsGrid.tsx:367:20" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="367" data-component-end-line="369" data-component-file="ProgramsGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20text-muted-foreground%22%7D" className="text-xs text-muted-foreground">
                      {fact.label}
                    </p>


                    <p data-component-id="src/app/programs/components/ProgramsGrid.tsx:372:20" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="372" data-component-end-line="374" data-component-file="ProgramsGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20font-semibold%20text-foreground%22%7D" className="text-sm font-semibold text-foreground">
                      {fact.value}
                    </p>

                  </div>


                </div>

              ))}


            </div>


          </div>



          {/* Details */}

          <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:393:10" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="393" data-component-end-line="542" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-7%22%7D" className="lg:col-span-7">


            <h3 data-component-id="src/app/programs/components/ProgramsGrid.tsx:396:12" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="396" data-component-end-line="398" data-component-file="ProgramsGrid.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-serif%20text-4xl%20text-foreground%20mb-2%22%7D" className="font-serif text-4xl text-foreground mb-2">
              {active.title}
            </h3>


            <p data-component-id="src/app/programs/components/ProgramsGrid.tsx:401:12" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="401" data-component-end-line="403" data-component-file="ProgramsGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted-foreground%20text-sm%20mb-4%22%7D" className="text-muted-foreground text-sm mb-4">
              {active.subtitle}
            </p>


            <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:406:12" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="406" data-component-end-line="406" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22divider%20mb-6%22%7D" className="divider mb-6" />


            <p data-component-id="src/app/programs/components/ProgramsGrid.tsx:409:12" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="409" data-component-end-line="411" data-component-file="ProgramsGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted-foreground%20leading-relaxed%20mb-8%22%7D" className="text-muted-foreground leading-relaxed mb-8">
              {active.description}
            </p>



            {/* Eligibility */}

            <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:417:12" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="417" data-component-end-line="438" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-8%22%7D" className="mb-8">

              <h4 data-component-id="src/app/programs/components/ProgramsGrid.tsx:419:14" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="419" data-component-end-line="429" data-component-file="ProgramsGrid.tsx" data-component-name="h4" data-component-content="%7B%22elementName%22%3A%22h4%22%2C%22className%22%3A%22font-semibold%20text-foreground%20text-sm%20mb-3%20flex%20items-center%20gap-2%22%2C%22textContent%22%3A%22Eligibility%20Criteria%22%7D" className="font-semibold text-foreground text-sm mb-3 flex items-center gap-2">

                <Icon data-component-id="src/app/programs/components/ProgramsGrid.tsx:421:16" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="421" data-component-end-line="425" data-component-file="ProgramsGrid.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ClipboardDocumentCheckIcon%22%2C%22className%22%3A%22text-primary%22%7D"
                  name="ClipboardDocumentCheckIcon"
                  size={16}
                  className="text-primary"
                />

                Eligibility Criteria

              </h4>


              <p data-component-id="src/app/programs/components/ProgramsGrid.tsx:432:14" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="432" data-component-end-line="436" data-component-file="ProgramsGrid.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%20bg-muted%20border%20border-border%20rounded-xl%20px-4%20py-3%22%7D" className="text-sm text-muted-foreground bg-muted border border-border rounded-xl px-4 py-3">

                {active.eligibility}

              </p>

            </div>



            {/* Curriculum */}

            <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:444:12" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="444" data-component-end-line="478" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-8%22%7D" className="mb-8">

              <h4 data-component-id="src/app/programs/components/ProgramsGrid.tsx:446:14" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="446" data-component-end-line="456" data-component-file="ProgramsGrid.tsx" data-component-name="h4" data-component-content="%7B%22elementName%22%3A%22h4%22%2C%22className%22%3A%22font-semibold%20text-foreground%20text-sm%20mb-4%20flex%20items-center%20gap-2%22%2C%22textContent%22%3A%22Key%20Subjects%22%7D" className="font-semibold text-foreground text-sm mb-4 flex items-center gap-2">

                <Icon data-component-id="src/app/programs/components/ProgramsGrid.tsx:448:16" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="448" data-component-end-line="452" data-component-file="ProgramsGrid.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22BookOpenIcon%22%2C%22className%22%3A%22text-primary%22%7D"
                  name="BookOpenIcon"
                  size={16}
                  className="text-primary"
                />

                Key Subjects

              </h4>


              <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:459:14" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="459" data-component-end-line="476" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20gap-3%22%7D" className="grid grid-cols-1 sm:grid-cols-2 gap-3">

                {active.curriculum.map((subject) => (

                  <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:463:18" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="463" data-component-end-line="472" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-3%20text-sm%20text-muted-foreground%22%7D"
                    key={subject}
                    className="flex items-center gap-3 text-sm text-muted-foreground"
                  >

                    <span data-component-id="src/app/programs/components/ProgramsGrid.tsx:468:20" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="468" data-component-end-line="468" data-component-file="ProgramsGrid.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22w-1.5%20h-1.5%20rounded-full%20bg-secondary%22%7D" className="w-1.5 h-1.5 rounded-full bg-secondary" />

                    {subject}

                  </div>

                ))}

              </div>

            </div>



            {/* Careers */}

            <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:484:12" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="484" data-component-end-line="522" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-8%22%7D" className="mb-8">

              <h4 data-component-id="src/app/programs/components/ProgramsGrid.tsx:486:14" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="486" data-component-end-line="496" data-component-file="ProgramsGrid.tsx" data-component-name="h4" data-component-content="%7B%22elementName%22%3A%22h4%22%2C%22className%22%3A%22font-semibold%20text-foreground%20text-sm%20mb-4%20flex%20items-center%20gap-2%22%2C%22textContent%22%3A%22Career%20Opportunities%22%7D" className="font-semibold text-foreground text-sm mb-4 flex items-center gap-2">

                <Icon data-component-id="src/app/programs/components/ProgramsGrid.tsx:488:16" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="488" data-component-end-line="492" data-component-file="ProgramsGrid.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22BriefcaseIcon%22%2C%22className%22%3A%22text-primary%22%7D"
                  name="BriefcaseIcon"
                  size={16}
                  className="text-primary"
                />

                Career Opportunities

              </h4>


              <div data-component-id="src/app/programs/components/ProgramsGrid.tsx:499:14" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="499" data-component-end-line="520" data-component-file="ProgramsGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-2%22%7D" className="flex flex-wrap gap-2">

                {active.careers.map((career) => (

                  <span data-component-id="src/app/programs/components/ProgramsGrid.tsx:503:18" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="503" data-component-end-line="516" data-component-file="ProgramsGrid.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20text-xs%20px-3%20py-1.5%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20rounded-full%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20bg-primary%2F8%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20text-primary%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20border%20border-primary%2F15%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%22%7D"
                    key={career}
                    className="
                      text-xs px-3 py-1.5
                      rounded-full
                      bg-primary/8
                      text-primary
                      border border-primary/15
                    "
                  >

                    {career}

                  </span>

                ))}

              </div>

            </div>



            <Link data-component-id="src/app/programs/components/ProgramsGrid.tsx:526:12" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="526" data-component-end-line="539" data-component-file="ProgramsGrid.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fadmissions%22%2C%22className%22%3A%22btn-primary%22%2C%22textContent%22%3A%22Apply%20for%22%7D"
              href="/admissions"
              className="btn-primary"
            >

              Apply for {active.title}

              <Icon data-component-id="src/app/programs/components/ProgramsGrid.tsx:533:14" data-component-path="src/app/programs/components/ProgramsGrid.tsx" data-component-line="533" data-component-end-line="537" data-component-file="ProgramsGrid.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ArrowRightIcon%22%2C%22className%22%3A%22text-white%22%7D"
                name="ArrowRightIcon"
                size={16}
                className="text-white"
              />

            </Link>


          </div>


        </div>

      )}

    </div>

  </section>
);
}